import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const rows = [{
  label: 'Tomo 1 — Protocolo de Anamnesis',
  price: '$27 USD'
}, {
  label: 'Tomo 2 — Laboratorio y Bioquímica',
  price: '$27 USD'
}, {
  label: 'Tomo 3 — Ingeniería de Planes',
  price: '$27 USD'
}, {
  label: 'Tomo 4 — Nutrición Clínica Aplicada',
  price: '$27 USD'
}, {
  label: 'Tomo 5 — Educación Alimentaria',
  price: '$27 USD'
}, {
  label: 'Tomo 6 — Práctica Profesional',
  price: '$27 USD'
}, {
  label: 'Bono 1 — Kit de WhatsApp',
  price: '$47 USD'
}, {
  label: 'Bono 2 — Composición Corporal',
  price: '$47 USD'
}, {
  label: 'Bono 3 — Guía Legal',
  price: '$47 USD'
}, {
  label: 'Bono 4 — Suplementación',
  price: '$47 USD'
}];
export function ValueStack() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-white px-5 py-12 sm:py-20" data-id="element-249" data-mp="30wtw93nmsmju">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-250" data-mp="35pwpfaohxtzi">
        <h2 className="text-center font-serif-display text-2xl font-bold text-slate sm:text-4xl" data-id="element-251" data-mp="23568dz8b1t0f">
          Todo lo que recibís hoy
        </h2>

        <div className="mt-6 rounded-2xl border border-sage/25 p-4 sm:mt-8 sm:p-6" data-id="element-252" data-mp="1ydo6n8ygjoee">
          <ul data-id="element-253" data-mp="2c52ze7i633yn">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-sage/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-254" data-mp="2c41ezcf9h549">
                <span className="text-[13px] text-slate/80 sm:text-sm" data-id="element-255" data-mp="2m4af31cdjaox">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-slate/60 sm:text-sm" data-id="element-256" data-mp="2h4fo6xslml3v">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-sage/30" data-id="element-257" data-mp="mqwj92w8o08j" />

          <div className="flex items-center justify-between" data-id="element-258" data-mp="mshdssijzj6e">
            <span className="text-[13px] text-slate/60 sm:text-sm" data-id="element-259" data-mp="2mtpb678tqr5i">Valor total del sistema</span>
            <span className="text-lg font-medium text-slate/50 line-through sm:text-xl" data-id="element-260" data-mp="2rrqu8s692qgz">
              $350 USD
            </span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-sage/10 py-5 text-center sm:py-6" data-id="element-261" data-mp="2vsj51purt3fd">
            <span className="text-sm font-medium text-dark-green" data-id="element-262" data-mp="30u8fp4e2zf2x">Tu inversión hoy</span>
            <span className="font-serif-display text-5xl font-bold text-sage sm:text-6xl" data-id="element-263" data-mp="35ridp8fjcz2d">
              $17 USD
            </span>
            <p className="mt-2 px-4 text-xs text-slate/60 sm:text-sm" data-id="element-264" data-mp="3fhtjl0is5ibw">
              Pago único · Sin suscripción · Acceso de por vida · PDF descargable
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-265" data-mp="3oijdfyohcymz">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-266" data-mp="3ojkpo6h8fr6a">
            <span className="text-xs font-bold tracking-widest text-dark-green uppercase" data-id="element-267" data-mp="3thcprns16jlk">
              Si accedes hoy
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-slate sm:text-3xl" data-id="element-268" data-mp="7gybm0nhonw6">
              Te llevas <span className="text-dark-green" data-id="element-269" data-mp="2fr4m3t67sqk">SIN CARGO</span> este súper bono
            </h3>
            <p className="mt-2 text-base font-medium text-slate/70 sm:text-lg" data-id="element-270" data-mp="3tnn4i1rj2ylk">
              Biblioteca Clínica Visual Nutri-Pro™
            </p>
            
            <div className="mt-6 w-full overflow-hidden rounded-xl border border-sage/20 bg-slate-50 shadow-sm" data-id="element-271" data-mp="q6wl8l6xqp1x">
              <video src="https://cdn.magicpatterns.com/uploads/sLgxa6igUDbvvuzT6nESQr/DRIVE-BONO-PRO-NUTRI.webm" controls playsInline className="w-full aspect-video object-cover" data-id="element-272" data-mp="l8v0zwxrwjov" />
            </div>
          </div>

          <CTAButton label="Obtener el acceso AHORA" href="https://sistema-nutri-pro-completo.impultienda.ar/checkout" data-id="element-273" data-mp="18y643l2liq66" />
          <TodayOfferCard data-id="element-274" data-mp="144uytodfmhgd" />
          <div className="mt-4 rounded-xl border border-sage/20 bg-sage/5 px-4 py-3 text-center" data-id="element-275" data-mp="144l3rmdj5k3t">
            <p className="text-sm font-bold text-dark-green" data-id="element-276" data-mp="oqr5sbi7l529">💱 Pagá fácilmente desde tu país</p>
            <p className="mt-1 text-xs leading-relaxed text-slate/70 sm:text-sm" data-id="element-277" data-mp="tl4vbxa6whz0">
              Aunque el precio está expresado en dólares, la plataforma realiza automáticamente la
              conversión a tu moneda local al momento del pago. Podés completar tu compra con tu
              tarjeta habitual, sin hacer cálculos ni trámites adicionales.
            </p>
            <p className="mt-2 text-xs leading-relaxed text-slate/60" data-id="element-278" data-mp="1cdh7fbqnaxmc">
              Antes de confirmar, podrás visualizar el importe correspondiente según el tipo de
              cambio aplicado por tu medio de pago.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}